// cloudDeckImport.js — Importer un deck depuis le DeckBuilder (Supabase Auth + table decklists)
// Version "architecture propre":
// - Supabase client unique via services.js (infra/supabaseClient.js)
// - Auth via authService
// - Decks via deckService
// - UI only in this file

import { initServices } from "./services.js";
import { login, getCurrentUser, logout } from "./auth/authService.js";
import { listDecks, loadDeck } from "./data/deckService.js";

initServices();

function $(id){ return document.getElementById(id); }

function pad3(n){
  const s = String(n ?? "").replace(/\D/g,'');
  return s.padStart(3,'0').slice(-3);
}

function buildDecklistText(deckRow){
  const name = deckRow?.name || "Mon Deck";
  const raw = deckRow?.deck;

  let entries = null;
  if(raw && Array.isArray(raw)) entries = raw;
  else if(raw && Array.isArray(raw.deck)) entries = raw.deck;
  else entries = [];

  const norm = entries
    .map(e => ({ number: Number(e.number), qty: Number(e.qty) }))
    .filter(e => Number.isFinite(e.number) && Number.isFinite(e.qty) && e.qty > 0)
    .sort((a,b)=>a.number-b.number);

  const total = norm.reduce((s,e)=>s+e.qty,0);
  const lines = [`# ${name} (${total}/40)`];

  for(const e of norm){
    const id = pad3(e.number);
    lines.push(`${e.qty}x [${id}] ${id}`);
  }
  return lines.join("\n");
}

function setStatus(t){
  const el = $("cloudStatus");
  if(el) el.textContent = t || "";
}

function escapeHtml(s){
  return String(s).replace(/[&<>"']/g, c => ({
    "&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;"
  }[c]));
}

async function refreshDeckSelect(){
  try{
    setStatus("Chargement des decks…");
    const decks = await listDecks();
    const sel = $("cloudDeckSelect");
    if(!sel) return;
    sel.innerHTML = `<option value="">— Mes decks —</option>` + decks.map(d =>
      `<option value="${escapeHtml(d.id)}">${escapeHtml(d.name || "Sans nom")}</option>`
    ).join("");
    setStatus(`${decks.length} deck(s)`);
  }catch(e){
    console.error(e);
    setStatus("Erreur chargement decks: " + (e?.message || String(e)));
  }
}

async function updateConnectedHint(){
  try{
    const user = await getCurrentUser();
    if(user?.email){
      setStatus(`Connecté: ${user.email}`);
    }
  }catch(_e){}
}

function wire(){
  const emailEl = $("cloudEmail");
  const passEl  = $("cloudPass");
  const loginBtn = $("cloudLogin");
  const refreshBtn = $("cloudRefresh");
  const importBtn = $("cloudImport");
  const selectEl = $("cloudDeckSelect");
  const deckTa = $("decklistInput");
  const importExisting = $("importDeckBtn");

  if(!emailEl || !passEl || !loginBtn || !refreshBtn || !importBtn || !selectEl) return;

  updateConnectedHint().then(() => refreshDeckSelect());

  loginBtn.addEventListener("click", async () => {
    const email = (emailEl.value || "").trim();
    const pass = (passEl.value || "");
    if(!email || !pass) return setStatus("Email + mot de passe requis");
    try{
      setStatus("Connexion…");
      const r = await login(email, pass, { createIfMissing: true });
      const user = r?.user || (await getCurrentUser());
      setStatus(user?.email ? `Connecté ✅ (${user.email})` : "Connecté ✅");
      await refreshDeckSelect();
    }catch(e){
      console.error(e);
      setStatus("Erreur connexion: " + (e?.message || String(e)));
    }
  });

  // Right-click => logout (dev/test friendly)
  loginBtn.addEventListener("contextmenu", async (ev) => {
    ev.preventDefault();
    try{
      await logout();
      setStatus("Déconnecté");
      if(selectEl) selectEl.innerHTML = `<option value="">— Mes decks —</option>`;
    }catch(e){
      console.error(e);
      setStatus("Erreur logout");
    }
  });

  refreshBtn.addEventListener("click", refreshDeckSelect);

  importBtn.addEventListener("click", async () => {
    const id = selectEl.value;
    if(!id) return setStatus("Choisis un deck");
    if(!deckTa) return setStatus("Zone decklist introuvable");
    try{
      setStatus("Import…");
      const row = await loadDeck(id);
      deckTa.value = buildDecklistText(row);
      if(importExisting) importExisting.click();
      setStatus("Deck importé ✅");
    }catch(e){
      console.error(e);
      setStatus("Erreur import: " + (e?.message || String(e)));
    }
  });
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded", wire, { once: true });
}else{
  wire();
}
